import React, { useRef, useState } from 'react';
import ReactRTE from 'react-rte';

import i18n from 'FRONTEND/utils/i18n';

const RichTextEditor = ({ inputName }) => {
  const toolbarConfig = {
    // Optionally specify the groups to display (displayed in the order listed).
    display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
    INLINE_STYLE_BUTTONS: [
      { label: i18n._('Bold'), style: 'BOLD' },
      { label: i18n._('Italic'), style: 'ITALIC' },
      { label: i18n._('Underline'), style: 'UNDERLINE' },
    ],
    BLOCK_TYPE_DROPDOWN: [
      { label: i18n._('Normal'), style: 'unstyled' },
      { label: i18n._('Heading large'), style: 'header-one' },
      { label: i18n._('Heading medium'), style: 'header-two' },
      { label: i18n._('Heading small'), style: 'header-three' },
    ],
    BLOCK_TYPE_BUTTONS: [
      { label: i18n._('UL'), style: 'unordered-list-item' },
      { label: i18n._('OL'), style: 'ordered-list-item' },
    ],
    HISTORY_BUTTONS: {
      redo: { label: i18n._('Redo') },
      undo: { label: i18n._('Undo') },
    },
  };

  /* const [value, setValue] = useState(() => {
    // Retrieving prescription draft from localStorage
    const diagnoseDraft = JSON.parse(window.localStorage.getItem(`${window.location.pathname}diagnose/`));
    return diagnoseDraft ? RichTextEditor.createValueFromString(diagnoseDraft[inputName], 'html') : RichTextEditor.createEmptyValue();
  }); */

  const [value, setValue] = useState(ReactRTE.createEmptyValue());
  const [valueSerialized, setValueSerialized] = useState('');
  const editorRef = useRef(null);

  const onChange = (value) => {
    setValue(value);
    setValueSerialized(value.toString('html'));
  };

  return (
    <div>
      <ReactRTE
        className='rich_text_editor'
        value={value}
        onChange={onChange}
        toolbarConfig={toolbarConfig}
        ref={editorRef}
      />
      <input
        className='hidden'
        name={inputName}
        value={valueSerialized}
        readOnly
      />
    </div>
  );
};

export default RichTextEditor;
